'use client';

import dynamic from 'next/dynamic';
import { SECOND_LINE } from '@/components/seo/roles';

// Client-only: the simulator is the editor's state, steps and three.js view,
// none of which belongs in this page's server bundle or its first paint.
const RoomAcousticsSimulator = dynamic(() => import('@/components/simulator/RoomAcousticsSimulator'), {
  ssr: false,
  loading: () => (
    <p className={`${SECOND_LINE} flex min-h-80 items-center justify-center`}>Loading the simulator…</p>
  ),
});

export default function SimulatorWidget() {
  return <RoomAcousticsSimulator />;
}
